import {
  ComponentBuilder,
  FunctionComponent
} from '../../component-builder/types';
import { DisplayConfigType } from '../../../lib/config';
import { Component as IconComponent } from './component';

export class OptoutIconBuilder implements ComponentBuilder<DisplayConfigType> {
  isInjectable(adContext: AdContext, formatConfig: DisplayConfigType): boolean {
    const { showOptoutLink, childPrivacyApplied } = adContext;
    return showOptoutLink === true || childPrivacyApplied === true;
  }

  build(adContext: AdContext, config: DisplayConfigType): FunctionComponent {
    return IconComponent;
  }
}
